import { Typography } from "@trustpilot/businessapp-patternlibrary";
import { Text } from "ilenia";
import React, { useContext } from "react";

import { SecondaryNavSub } from ".";
import { NavContext } from "../../index";
import styles from "../../styles/sideNav.module.scss";
import * as Types from "../../types";

interface SecondaryNavProps {
  secondaryMenu: Types.SubItem[];
  setIsMainMenuCollapsed: (value: boolean) => void;
}
const SecondaryNav: React.FC<SecondaryNavProps> = ({ secondaryMenu, setIsMainMenuCollapsed }) => {
  const { navItems } = useContext(NavContext);

  return (
    <>
      <div>
        {secondaryMenu && (
          <ul>
            <div className={styles.sidebarPrimaryMenu}>
              {" "}
              {navItems?.isOpenPrimarySubmenu && (
                <Typography variant="heading-xxxs">
                  <Text id={`Sidebar.${navItems?.isOpenPrimarySubmenu}`} />
                </Typography>
              )}
            </div>

            {secondaryMenu.map((menu) => (
              <SecondaryNavSub menu={menu} key={`item-${menu.id}`} setIsMainMenuCollapsed={setIsMainMenuCollapsed} />
            ))}
          </ul>
        )}
      </div>
    </>
  );
};

export default SecondaryNav;
